var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPalette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H13.5C6.05625 0 0 6.05625 0 13.5C0 20.9438 6.05625 27 13.5 27H16.5C17.3272 27 18 27.6728 18 28.5C18 29.3272 17.3272 30 16.5 30C11.5372 30 7.5 34.0373 7.5 39C7.5 43.9627 11.5372 48 16.5 48H24C37.2337 48 48 37.2337 48 24C48 10.7662 37.2337 0 24 0Z",
    fill: "url(#paint0_linear_1040_50)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6C9.3645 6 6 9.3645 6 13.5C6 17.6355 9.3645 21 13.5 21C17.6355 21 21 17.6355 21 13.5C21 9.3645 17.6355 6 13.5 6Z",
    fill: "url(#paint1_linear_1040_50)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 33C26.0182 33 24 35.0182 24 37.5C24 39.9818 26.0182 42 28.5 42C30.9818 42 33 39.9818 33 37.5C33 35.0182 30.9818 33 28.5 33Z",
    fill: "url(#paint2_linear_1040_50)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 25.5C35.0182 25.5 33 27.5182 33 30C33 32.4818 35.0182 34.5 37.5 34.5C39.9818 34.5 42 32.4818 42 30C42 27.5182 39.9818 25.5 37.5 25.5Z",
    fill: "url(#paint3_linear_1040_50)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 22.5C39.9818 22.5 42 20.4818 42 18C42 15.5182 39.9818 13.5 37.5 13.5C35.0182 13.5 33 15.5182 33 18C33 20.4818 35.0182 22.5 37.5 22.5Z",
    fill: "url(#paint4_linear_1040_50)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15C30.9818 15 33 12.9818 33 10.5C33 8.01825 30.9818 6 28.5 6C26.0182 6 24 8.01825 24 10.5C24 12.9818 26.0182 15 28.5 15Z",
    fill: "url(#paint5_linear_1040_50)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1040_50",
    x1: 4.8495,
    y1: 40.0718,
    x2: 39.423,
    y2: 5.49825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1040_50",
    x1: 8.19975,
    y1: 18.801,
    x2: 18.801,
    y2: 8.19975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1040_50",
    x1: 25.32,
    y1: 40.6808,
    x2: 31.6808,
    y2: 34.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1040_50",
    x1: 34.32,
    y1: 33.1815,
    x2: 40.6815,
    y2: 26.8207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1040_50",
    x1: 34.32,
    y1: 21.1807,
    x2: 40.6815,
    y2: 14.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1040_50",
    x1: 25.3192,
    y1: 13.6807,
    x2: 31.6807,
    y2: 7.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPalette);
export default __webpack_public_path__ + "static/media/color-palette.785aa8947a6534e5819d9ecc386b7371.svg";
export { ForwardRef as ReactComponent };